import { FunctionCloneDeep } from "radium-omnibus";
import {
  PageSaparate,
  PageSaparateEn,
} from "../../../context/Context.Language";

export const FunctionCheckIsTH = (to) => {
  const location = window.location.pathname;
  const isCurrentTH = location?.includes("/TH");
  const checkHasTH =
    PageSaparateEn?.findIndex((item) => {
      return item === to;
    }) !== -1 && isCurrentTH;

  // console.log("CHECK PATH ", {
  //   location,
  //   isCurrentTH,
  //   checkHasTH,
  //   to,
  // });

  if (checkHasTH) {
    return true;
  } else {
    return false;
  }
};

const ProgramClickBack = (navigate) => {
  const location = window.location.pathname;
  let history = FunctionCloneDeep(
    JSON.parse(sessionStorage.getItem("redirect-keep-history"))
  );
  const isCurrentTH = location?.includes("/TH");

  const newHistory = history?.filter((item) => {
    return (
      item !== location &&
      item !== location + "/TH" &&
      (isCurrentTH ? item !== location.replace("/TH", "") : true)
    );
  });
  const lastPage = FunctionCloneDeep(
    newHistory?.[newHistory?.length - 1] || "/"
  );

  //remove last index from history

  let i = history.length - 1;
  while (i > 0 && history[i] === history[i - 1]) {
    history.splice(i, 1);
    i--;
  }

  history.pop();

  sessionStorage.setItem("redirect-keep-history", JSON.stringify(history));

  // const getAmostLastPage =
  try {
    navigate(lastPage);

    // console.log("location", {
    //   history,
    //   location,
    //   isCurrentTH,
    //   newHistory,
    //   lastPage,
    // });
    // navigate(-1);
  } catch (error) {
    console.error("ProgramClickBack  :", error);
  }
};

export default ProgramClickBack;
